var _circle, _path, _circle2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.7852,
    cy: 17,
    r: 16.3108,
    stroke: "#A5A5A5",
    strokeWidth: 1.37838
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7963 27.4154C18.4374 27.7743 17.8556 27.7743 17.4967 27.4154L11.6487 21.5674C11.2899 21.2086 11.2899 20.6267 11.6487 20.2679C12.0076 19.909 12.5894 19.909 12.9483 20.2679L18.1465 25.4661L23.3447 20.2679C23.7035 19.909 24.2854 19.909 24.6442 20.2679C25.0031 20.6267 25.0031 21.2086 24.6442 21.5674L18.7963 27.4154ZM17.2276 7.00887C17.2276 6.50137 17.639 6.08995 18.1465 6.08995C18.654 6.08995 19.0654 6.50137 19.0654 7.00887L17.2276 7.00887ZM17.2276 26.7656L17.2276 7.00887L19.0654 7.00887L19.0654 26.7656L17.2276 26.7656Z",
    fill: "#A5A5A5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 16.3108,
    stroke: "#A5A5A5",
    strokeWidth: 1.37838
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0111 27.4154C18.6522 27.7743 18.0704 27.7743 17.7116 27.4154L11.8636 21.5674C11.5047 21.2086 11.5047 20.6267 11.8636 20.2679C12.2225 19.909 12.8043 19.909 13.1631 20.2679L18.3613 25.4661L23.5595 20.2679C23.9184 19.909 24.5002 19.909 24.8591 20.2679C25.2179 20.6267 25.2179 21.2086 24.8591 21.5674L19.0111 27.4154ZM17.4424 7.00887C17.4424 6.50137 17.8538 6.08995 18.3613 6.08995C18.8688 6.08995 19.2802 6.50137 19.2802 7.00887L17.4424 7.00887ZM17.4424 26.7656L17.4424 7.00887L19.2802 7.00887L19.2802 26.7656L17.4424 26.7656Z",
    fill: "#A5A5A5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.0dda76d353627ef6000f4d42b2337b14.svg";
export { ForwardRef as ReactComponent };